module.exports = __webpack_public_path__ + "static/img/page1-bg.1c4391d8.png";